import React from "react";
import ReactDOM from "react-dom/client";
import "assets/scss/common.scss";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
/* 
조회수가 2회씩 올라가서 StrictMode를 해제했다.
*/
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
